/**
 * @author: dongjing
 * @file: description
 * @Date: 2019-12-11 14:12:17
 * @LastEditors: dongjing
 * @LastEditTime: 2019-12-12 11:37:03
 */
import React from 'react';
import { Pagination } from 'antd';
import './SFCPagination.less';

export interface ISFCPaginationProps {
  /** 当前页数 */
  pageNum: number;
  /** 每页数量 */
  pageSize: number;
  /** 总数 */
  total: number;
  /** 更改函数 */
  onChange: (page: number) => void;
}
type Props = ISFCPaginationProps;

export function SFCPagination(props: Readonly<Props>) {
  const { total, pageSize, pageNum, onChange } = props;
  return (
    <div className="common-presenter k-common-pagination">
      <Pagination total={total} current={pageNum} pageSize={pageSize} onChange={onChange} />
    </div>
  );
}

export default SFCPagination;
